// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cm24-phone-input[data-v-3581e181] .country-code{min-width:75px!important}.cm24-link-btn[data-v-3581e181]{height:auto!important;letter-spacing:normal;min-width:0!important;padding:0!important;-webkit-text-decoration:underline;text-decoration:underline;text-transform:none}.cm24-link-btn[data-v-3581e181] .v-btn__content{opacity:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
